import { IPaymentType } from '../../types'
import {TApiEnums} from '../../../services/_common'
import { enumTransformer } from '../../../services/_common/utils'

export function parsePaymentTypes(response: TApiEnums): IPaymentType[] {
    return response.entities.map((item) => enumTransformer(item))
}